import * as React from "react";
import { connect } from "react-redux";
import { values } from "lodash";

import { acceptableExtensions } from "@teamprevent/common/acceptableExtensions";
import { OldProgressBarQuestionnaireSectionUnconnected } from "@teamprevent/common/questionnaires/components/OldProgressBarQuestionnaireSection";
import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";
import { mapDispatchToQuestionnaireSectionProps, makeMapStateToQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/mappers";
import { CustomQuestionsQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/QuestionnaireSectionProps";
import { TextQuestion } from "@teamprevent/common/questionnaires/components/questions/TextQuestion";
import { CheckboxQuestion } from "@teamprevent/common/questionnaires/components/questions/CheckboxQuestion";
import { FilesQuestion } from "@teamprevent/common/questionnaires/components/questions/FilesQuestion";
import { MultiButtonQuestion } from "@teamprevent/common/questionnaires/components/questions/MultiButtonQuestion";
import { getAnswerToQuestionWithId } from "@teamprevent/common/questionnaires/getAnswerToQuestionWithId";

import { FileAnswer } from "@teamprevent/common/questionnaires/model";

import * as questionIds from "../consultationQuestions/questionIds";
import { sections } from "../consultation";

interface Props extends CustomQuestionsQuestionnaireSectionProps {
    fileUploadApi: string;
    onFileUpload?: (file: File) => Promise<string>;
    onDeleteFile?: (fileId: string, fileName: string, ohCaseDocumentId?: string) => Promise<void>;
    getDownloadLink: (fileAnswer: FileAnswer) => string;
}

const HealthSurveillanceConsultationGeneralClinicNotesSectionUnconnected: React.FunctionComponent<Props> = (props: Props) => {

    const questions = values(props.questions || {});

    return (
        <OldProgressBarQuestionnaireSectionUnconnected
            {...props}
            {...sections.GeneralClinicNotes}
        >
            <MultiButtonQuestion
                readonly={props.readonly}
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.AdvisedEmployeeTemporarilyUnfitToCarryOutDuties)}
                mandatory
                outdated={{
                    isOutdated: false,
                    questionnaireKey: props.questionnaireKey,
                    sectionId: sections.GeneralClinicNotes.id
                }}
            />
            {getAnswerToQuestionWithId(questions, questionIds.AdvisedEmployeeTemporarilyUnfitToCarryOutDuties) === MultiButtonQuestion.YesOption && <>
                <TextQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.PleaseDocumentTheReasonsForTheAboveDecision)}
                    mandatory
                    multiline
                    outdated={{
                        isOutdated: false,
                        questionnaireKey: props.questionnaireKey,
                        sectionId: sections.GeneralClinicNotes.id
                    }}
                />
            </>}
            <MultiButtonQuestion
                readonly={props.readonly}
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.AdvisedToDiscussTemporarilyUnfitStatusWithLineManager)}
                mandatory
                outdated={{
                    isOutdated: false,
                    questionnaireKey: props.questionnaireKey,
                    sectionId: sections.GeneralClinicNotes.id
                }}
            />
            <CheckboxQuestion
                readonly={props.readonly}
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.InformedCaseWillBeAssessedByOha)}
                value="Yes"
                mandatory
                outdated={{
                    isOutdated: false,
                    questionnaireKey: props.questionnaireKey,
                    sectionId: sections.GeneralClinicNotes.id
                }}
            />
            <MultiButtonQuestion
                readonly={props.readonly}
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.ConfirmIfEmployeeHasProvidedConsentToProvideInformationToEmployer)}
                mandatory
                outdated={{
                    isOutdated: false,
                    questionnaireKey: props.questionnaireKey,
                    sectionId: sections.GeneralClinicNotes.id
                }}
            />
            {/*  eslint-disable-next-line max-len */}
            {getAnswerToQuestionWithId(questions, questionIds.ConfirmIfEmployeeHasProvidedConsentToProvideInformationToEmployer) === MultiButtonQuestion.YesOption &&
             <>
                 <TextQuestion
                     readonly={props.readonly}
                     questionConfig={getQuestionConfig(props.questionConfigs, questionIds.ProvideDetailsOfTheConsent)}
                     mandatory
                     multiline
                     outdated={{
                         isOutdated: false,
                         questionnaireKey: props.questionnaireKey,
                         sectionId: sections.GeneralClinicNotes.id
                     }}
                 />
             </>}
            <TextQuestion
                readonly={props.readonly}
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.GeneralNotes)}
            />
            <FilesQuestion
                api={props.fileUploadApi}
                onUpload={props.onFileUpload}
                readonly={props.readonly}
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.MedicalDocuments)}
                getDownloadLink={props.getDownloadLink}
                onDeleteFile={props.onDeleteFile}
                acceptExtensions={acceptableExtensions}
            />
            <CheckboxQuestion
                readonly={props.readonly}
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.AnyDocumentsSentViaPost)}
                value="Yes"
            />
            <CheckboxQuestion
                readonly={props.readonly}
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.ConsentGiven)}
                mandatory
                value="Yes"
            />
        </OldProgressBarQuestionnaireSectionUnconnected>
    );
};

// eslint-disable-next-line max-len
export const HealthSurveillanceConsultationGeneralClinicNotesSection = connect(makeMapStateToQuestionnaireSectionProps(sections.GeneralClinicNotes.id), mapDispatchToQuestionnaireSectionProps)(HealthSurveillanceConsultationGeneralClinicNotesSectionUnconnected);
